<div style="font-family: Oswald, sans-serif !important">
  <div style="box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.75)">
    <app-header></app-header>
  </div>
  <div
    class="custom_scrollbar"
    style="overflow-y: scroll; height: calc(100vh - 50px)"
  >
    <div class="container">
      <div>
        <h1 #pricingSection class="mb-3 fs-1">Pricing</h1>

        <!-- <p class="mb-4">
          Connectnow offers a wide range of cutting-edge communication services,
          including human-to-human and human-to-AI calls and chats, all designed
          to enhance your experience with reliable and transparent pricing.
        </p> -->
        <div style="font-size: 17px; line-height: 1.6">
          <p>
            At ConnectNow, we believe in making meaningful interactions
            effortless and accessible. Whether it's a face-to-face video call, a
            quick chat, or an AI-powered assistant, our pricing is designed to
            match the value you receive—no hidden fees, just clear and flexible
            options.
          </p>
          <p>
            Pay only for what you use. Scale as you grow. Empower your team and
            let AI handle the rest.
          </p>
        </div>

        <!-- pricing -->
        <div class="mt-5">
          <div class="px-0 my-3 flex-column flex-md-row">
            <div class="mx-0 px-0">
              <div class="row">
                <div class="col-style col-12 col-lg-3 col-md-6 mb-4">
                  <div class="price-card text-center p-3">
                    <div class="title mt-3">
                      <p>
                        Human-to-human <br />
                        audio & video call
                      </p>
                    </div>
                    <div class="price mt-3">
                      <h4 style="white-space: nowrap"><sup>$</sup>0.12</h4>
                    </div>

                    <div class="price-info">
                      <sub>per minute</sub>
                    </div>
                  </div>
                </div>

                <div class="col-style col-12 col-lg-3 col-md-6 mb-4">
                  <div class="price-card text-center p-3">
                    <div class="title mt-3">
                      <p>Human-to-human chat</p>
                    </div>
                    <div class="price mt-3">
                      <h4 style="white-space: nowrap"><sup>$</sup>0.06</h4>
                    </div>

                    <div class="price-info">
                      <sub>per minute</sub>
                    </div>
                  </div>
                </div>

                <div class="col-style col-12 col-lg-3 col-md-6 mb-4">
                  <div class="price-card text-center p-3">
                    <div class="title mt-3">
                      <p>Human to AI audio call</p>
                    </div>
                    <div class="price mt-3">
                      <h4 style="white-space: nowrap"><sup>$</sup>0.20</h4>
                    </div>

                    <div class="price-info">
                      <sub>per minute</sub><br />
                      <sub>(SIP - $0.25/min)</sub>
                    </div>
                  </div>
                </div>

                <div class="col-style col-12 col-lg-3 col-md-6 mb-4">
                  <div class="price-card text-center p-3">
                    <div class="title mt-3">
                      <p>Human to AI chat</p>
                    </div>
                    <div class="price mt-3">
                      <h4 style="white-space: nowrap"><sup>$</sup>0.10</h4>
                    </div>

                    <div class="price-info">
                      <sub>per minute</sub>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer mt-5">
      <app-footer></app-footer>
    </div>
  </div>
</div>
